import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIfetchUserProfileById } from '../api/User';

import Avatar from '../components/Avatar';
import UserProfileActions from '../components/UserProfile/Actions';
import UserProfileEmail from '../components/UserProfile/Email';
import UserProfileFields from '../components/UserProfile/Fields';
import UserProfileHeader from '../components/UserProfile/Header';
import UserProfileTime from '../components/UserProfile/Time';
import UserProfilePhone from '../components/UserProfile/Phone';
import UserProfileTitle from '../components/UserProfile/Title';

import {
  getCurrentUser,
  userIsAdmin,
  userIsManager,
} from '../helpers/Auth';

import Loading from '../components/Loading';
import NothingFound from '../components/NothingFound';

const UserProfile = () => {
  const intl = useIntl();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userUuid } = useParams();

  const isCurrentUserProfile = profile && profile.uuid === getCurrentUser().uuid;

  useEffect(() => {
    setLoading(true);
    APIfetchUserProfileById(userUuid).then((response) => {
      setProfile(response.data);
    }).catch(() => {
      setProfile(null);
    }).finally(() => {
      setLoading(false);
    });
  }, [userUuid]);

  return (
    <div className="main-content split-content user-profile">
      <div className="split-content-wrapper">
        <Container fluid>
          <UserProfileHeader profile={profile} />
          <div className="content-wrapper user-profile-wrapper">
            {profile ? (
              <Row>
                <Col className="avatar-container">
                  <Avatar user={profile} size={200} />
                </Col>
                <Col>
                  <div className="user-profile-header">
                    <UserProfileTitle profile={profile} />
                  </div>
                  <div className="user-profile-details">
                    <ul className="user-profile-details-list">
                      <UserProfileTime profile={profile} />
                      {(userIsAdmin() || userIsManager()) && (
                        <UserProfileEmail profile={profile} />
                      )}
                      <UserProfilePhone profile={profile} />
                    </ul>
                  </div>
                  <UserProfileFields profile={profile} />

                  {profile && (userIsAdmin() || userIsManager() || isCurrentUserProfile) && (
                    <UserProfileActions profile={profile} />
                  )}
                </Col>
              </Row>
            ) : (
              <>
                {!loading && (
                  <NothingFound text={intl.formatMessage({ defaultMessage: 'User not found' })} />
                )}
              </>
            )}
            {loading && (
              <Loading />
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default UserProfile;
